var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle8, _circle9, _circle10, _path8, _circle11, _path9, _path10, _path11, _path12, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInsights = function SvgInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1246,
    height: 1062,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 808,
    r: 10,
    fill: "url(#insights_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 591,
    r: 10,
    fill: "url(#insights_svg__b)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 339,
    cy: 642,
    r: 10,
    fill: "url(#insights_svg__c)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 453,
    cy: 531,
    r: 10,
    fill: "url(#insights_svg__d)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 571,
    cy: 652,
    r: 10,
    fill: "url(#insights_svg__e)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 426,
    r: 10,
    fill: "url(#insights_svg__f)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 461,
    r: 10,
    fill: "url(#insights_svg__g)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 794.5 214.5 604",
    stroke: "url(#insights_svg__h)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m238 598.5 86 37.5",
    stroke: "url(#insights_svg__i)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2 765 86 37.5",
    stroke: "url(#insights_svg__j)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m351.5 629.5 87-85.5",
    stroke: "url(#insights_svg__k)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m469 543 86 98",
    stroke: "url(#insights_svg__l)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m585 640 103.5-197.5",
    stroke: "url(#insights_svg__m)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m720 428 87 31",
    stroke: "url(#insights_svg__n)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 309,
    r: 10,
    fill: "url(#insights_svg__o)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 443,
    r: 10,
    fill: "url(#insights_svg__p)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 563,
    cy: 279,
    r: 10,
    fill: "url(#insights_svg__q)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M776.5 295 896 226.5",
    stroke: "url(#insights_svg__r)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 299,
    r: 10,
    fill: "url(#insights_svg__s)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 311 345 434.5",
    stroke: "url(#insights_svg__t)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 416.5 147 316",
    stroke: "url(#insights_svg__u)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m378.5 434 168-148",
    stroke: "url(#insights_svg__v)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m581 277.5 162 18",
    stroke: "url(#insights_svg__w)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.38 839.134a375.5 375.5 0 0 1-42.414-429.577l326.993 184.597-284.579 244.98Z",
    fill: "url(#insights_svg__x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.351 393.607a375.501 375.501 0 0 1 227.177-176.03l98.898 362.242-326.075-186.212Z",
    fill: "url(#insights_svg__y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.845 165.818a375.5 375.5 0 0 1 158.298-4.171l-69.48 369.016-88.818-364.845Z",
    fill: "url(#insights_svg__z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.04 457.657a375.507 375.507 0 0 1-121.321 441.136l-226.456-299.53 347.777-141.606Z",
    fill: "url(#insights_svg__A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.259 906.637a375.502 375.502 0 0 1-507.204-54.811l283.208-246.563 223.996 301.374Z",
    fill: "url(#insights_svg__B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.583 140.16a375.489 375.489 0 0 1 274.977 224.686L771.72 508.72l71.863-368.56Z",
    fill: "url(#insights_svg__C)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__a",
    x1: 107,
    y1: 798,
    x2: 107,
    y2: 818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__b",
    x1: 223,
    y1: 581,
    x2: 223,
    y2: 601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__c",
    x1: 339,
    y1: 632,
    x2: 339,
    y2: 652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__d",
    x1: 453,
    y1: 521,
    x2: 453,
    y2: 541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__e",
    x1: 571,
    y1: 642,
    x2: 571,
    y2: 662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__f",
    x1: 700,
    y1: 416,
    x2: 700,
    y2: 436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__g",
    x1: 826,
    y1: 451,
    x2: 826,
    y2: 471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__h",
    x1: 226,
    y1: 630.5,
    x2: 194.123,
    y2: 810.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__i",
    x1: 320.5,
    y1: 642,
    x2: 235.213,
    y2: 633.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__j",
    x1: 84.5,
    y1: 808.5,
    x2: -0.787,
    y2: 800.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__k",
    x1: 450.5,
    y1: 517,
    x2: 403.049,
    y2: 651.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__l",
    x1: 550.5,
    y1: 577,
    x2: 466.232,
    y2: 576.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__m",
    x1: 668.5,
    y1: 692,
    x2: 584.232,
    y2: 691.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__n",
    x1: 803.5,
    y1: 466,
    x2: 719.232,
    y2: 465.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__o",
    x1: 165,
    y1: 299,
    x2: 165,
    y2: 319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__p",
    x1: 364,
    y1: 433,
    x2: 364,
    y2: 453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__q",
    x1: 563,
    y1: 269,
    x2: 563,
    y2: 289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__r",
    x1: 905.5,
    y1: 235.5,
    x2: 802.899,
    y2: 305.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__s",
    x1: 762,
    y1: 289,
    x2: 762,
    y2: 309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__t",
    x1: 343,
    y1: 384.5,
    x2: 177.062,
    y2: 372.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__u",
    x1: 149.5,
    y1: 324.5,
    x2: 99.333,
    y2: 392.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__v",
    x1: 555.5,
    y1: 293.5,
    x2: 461.239,
    y2: 414.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__w",
    x1: 738.5,
    y1: 315,
    x2: 589.077,
    y2: 339.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__x",
    x1: 669,
    y1: 587,
    x2: 301,
    y2: 614.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__y",
    x1: 475.5,
    y1: 268,
    x2: 673.5,
    y2: 558.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__z",
    x1: 440.297,
    y1: 255.366,
    x2: 951.03,
    y2: 805.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__A",
    x1: 699,
    y1: 599,
    x2: 1028,
    y2: 779.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__B",
    x1: 686.5,
    y1: 613.5,
    x2: 631.548,
    y2: 976.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "insights_svg__C",
    x1: 1057,
    y1: 151.5,
    x2: 772,
    y2: 509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })))));
};

export { SvgInsights as ReactComponent };
export default "data:image/svg+xml;base64,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";